import React from 'react';

const FormWelcome = ({children}) => {

    return (
        <div>
            <h1>{children}</h1>
            <div>
            Выберите категорию или товар для редактирования.<br/>
            Или добавьте новые.
            </div>
        </div>
    )
}

export default FormWelcome